import React from 'react';
import {Field} from 'react-final-form';
import {Input, Label, InputGroup, InputGroupAddon, InputGroupText} from 'reactstrap';
import {getDirection, numberWithCommas, stringToNumber} from '../helpers/Utils';
import FieldError from './FieldError';
import {required} from '../helpers/Validators';
import {withTranslation} from 'react-i18next';

class PriceField extends React.Component{
  render() {
    const {item, t} = this.props;
    const isRtl = getDirection().isRtl;
    return (
      <Field
        name={item.name}
        validate={item.required ? required : null}>
        {({input}) => (
          <div>
            <Label className="form-group has-float-label mb-2">
              <div>
                <span>
                  {item.i18n}
                  {typeof item.valid === 'boolean' &&
                  <span className={item.valid ? 'text-success' : 'text-danger'}>
                      {item.valid ? ` (${t('confirmed')})` : ` (${t('not confirmed')})`}
                    </span>
                  }
                </span>
                {item.required ? <span className="required">*</span> : ''}
              </div>
              <InputGroup>
                <Input
                  {...item}
                  {...input}
                  className={item.customClass}
                  value={numberWithCommas(input.value)}
                  onChange={e => {input.onChange(stringToNumber(e.target.value));}}
                />
                <FieldError name={item.name} style={{zIndex: 10, top: 40}}/>
                {!!item.unit && <InputGroupAddon addonType='append'>
                  <InputGroupText
                    className={`${isRtl ? 'border-right-0' : ''} d-flex align-items-center justify-content-center`}
                    style={{minWidth: 42}}>
                    {item.unit}
                  </InputGroupText>
                </InputGroupAddon>}
              </InputGroup>
            </Label>
          </div>
        )}
      </Field>
    );
  }
}

export default withTranslation()(PriceField);
